import styles from "../styles/main.module.css";
import Nav from "../Components/Nav";

const Landing = () => {

    return (
        <div>
            <Nav />
            <div className={styles.main}>
                <h2>Alec Dewulf</h2>
                <p>
                    I am an undergraduate at the University of Toronto studying computer science, mathematics
                    and statistics. I am currently an intern at <a href="https://www.embarclab.com/">embARC Lab</a> where I work on differential privacy 
                    in deep learning.
                </p>
                <p>
                    Previously, I was at the HMS/BWH <a href="https://search.bwh.harvard.edu/new/index.html">Visual Attention Lab</a>, where 
                    I studied the state of AI in mammography. I worked on visual priming at the 2021 <a href="https://www.cee.org/programs/research-science-institute">Research Science Institute</a> under
                    Dr. Jeremy Wolfe.
                </p>
                <p>
                    I'm interested in a lot of things, but right now, I'm mostly focused on differential privacy and complexity theory.
                    You can reach me at adewulf [at] cs [dot] toronto [dot] edu. 
                </p>
                <h3 style={{marginTop:"50px"}}>Past work</h3>
                <p>
                Wolfe, J. M., Suresh, S. B., <u>Dewulf, A. W.</u>, & Lyu, W. (2022). <a href="https://link.springer.com/article/10.3758/s13414-022-02503-5">
                    Priming effects in inefficient visual search: Real, but transient.</a> Attention, Perception, & Psychophysics, 1-15
                </p>
            </div>
            
           
        </div>
    )
}

export default Landing;